var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10L3.78125 9.71919C3.75281 9.68268 3.71994 9.64381 3.6835 9.60071C3.62649 9.53329 3.56075 9.45554 3.48958 9.36037C2.5125 8.20593 0.5 5.78783 0.5 3.74415C0.5 1.68487 2.075 0 4 0C5.925 0 7.5 1.68487 7.5 3.74415C7.5 5.72889 5.58656 8.05728 4.61634 9.23789L4.55417 9.31357C4.47588 9.41593 4.40278 9.50164 4.34106 9.574L4.34104 9.57403C4.29929 9.62298 4.26275 9.66582 4.23333 9.70359L4 10ZM4 0.624023C2.39583 0.624023 1.08333 2.02808 1.08333 3.74415C1.08333 5.51385 2.98002 7.82064 3.85482 8.88459L3.9125 8.95476C3.94167 8.98596 3.97083 9.01716 3.98542 9.04836C4.01458 9.00156 4.05833 8.95476 4.10208 8.90796C4.94792 7.89391 6.91667 5.52262 6.91667 3.74415C6.91667 2.02808 5.60417 0.624023 4 0.624023ZM4.00033 5.22608C3.11074 5.22608 2.39616 4.46165 2.39616 3.51001C2.39616 2.55838 3.11074 1.79395 4.00033 1.79395C4.88991 1.79395 5.60449 2.55838 5.60449 3.51001C5.60449 4.46165 4.88991 5.22608 4.00033 5.22608ZM4.00033 2.41699C3.43158 2.41699 2.97949 2.90061 2.97949 3.50904C2.97949 4.11746 3.43158 4.60108 4.00033 4.60108C4.56908 4.60108 5.02116 4.11746 5.02116 3.50904C5.02116 2.90061 4.56908 2.41699 4.00033 2.41699Z",
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a8d39fe1e05a9058cf63ab37fbfa1464.svg";
export { ForwardRef as ReactComponent };